
var thermalData = [
        {   name:'TNC225R',
            img:'https://us.dntoptics.com/cdn/shop/files/TNC225R_-_Thermal_Night_Vision_Multi-spectum_Scope_with_Laser_Rangefinder_and_Ballistic_Calculator-1-A.jpg?v=1718603936',
            seriesParam:[
                {
                    seriesName:'Thermal Specifications',
                    data:[
                        {name:'Thermal resolution',val:'256x192 pixels'},
                        {name:'Frame rate',val:'50FPS'},
                        {name:'Magnification',val:'3-12x'},
                        {name:'Field of View(HxV)',val:'12.3yd@100yd x 9.2yd@100yd'},
                    ]
                },
                {
                    seriesName:'Digital Day/Night Specifications',
                    data:[
                        {name:'Resolution',val:'1920x1080 pixels'},
                        {name:'Frame rate',val:'60Hz'},
                        {name:'Magnification',val:'5x - 20x'},
                    ]
                }
            ]
        },
        {   name:'TNC335R',
            img:'https://us.dntoptics.com/cdn/shop/files/TNC335R-ThermNight-Thermal_Night-Vision-Multispectral-Scope1.jpg?v=1731997769',
            seriesParam:[
                {
                    seriesName:'Thermal Specifications',
                    data:[
                        {name:'Thermal resolution',val:'384x288 pixels'},
                        {name:'Frame rate',val:'50FPS'},
                        {name:'Magnification',val:'2.5-10x'},
                        {name:'Field of View(HxV)',val:'13.2yd@100yd x 9.9yd@100yd'},
                    ]
                },
                {
                    seriesName:'Digital Day/Night Specifications',
                    data:[
                        {name:'Resolution',val:'1920x1080 pixels'},
                        {name:'Frame rate',val:'60Hz'},
                        {name:'Magnification',val:'5x - 20x'},
                    ]
                }
            ]
        },
        {   name:'TNC635R',
            img:'https://us.dntoptics.com/cdn/shop/files/TNC635R-ThermNight-Thermal_Night-Vision-Multispectral-Scope1.jpg?v=1731997968',
            seriesParam:[
                {
                    seriesName:'Thermal Specifications',
                    data:[
                        {name:'Thermal resolution',val:'640x512 pixels'},
                        {name:'Frame rate',val:'50FPS'},
                        {name:'Magnification',val:'1.5-6x'},
                        {name:'Field of View(HxV)',val:'21.9yd@100yd x 17.6yd@100yd'},
                    ]
                },
                {
                    seriesName:'Digital Day/Night Specifications',
                    data:[
                        {name:'Resolution',val:'1920x1080 pixels'},
                        {name:'Frame rate',val:'60Hz'},
                        {name:'Magnification',val:'5x - 20x'},
                    ]
                }
            ]
        }
    ]

var hydraData = [
        {   name:'HS219',
            img:'https://mmykg4ij91v36m7a-70667763947.shopifypreview.com/cdn/shop/files/HS219_9.jpg?v=1757580853',
            seriesParam:[
                {
                    seriesName:'Thermal Sensor Specifications',
                    data:[
                        {name:'Resolution',val:'256x192 pixels'},
                        {name:'Image Sensor',val:'Uncooled infrared sensor'},
                        {name:'Frame Rate',val:'50FPS'},
                        {name:'Pixel Size',val:'12x12um'},
                        {name:'NETD',val:'≤25mk @25℃'},
                        {name:'Objective Lens Focal Length',val:'19mm'},
                        {name:'Base Magnification',val:'2x'},
                        {name:'Digital Magnification',val:'2-8x'},
                        {name:'Field of View(HxV)',val:'16.2yd@100yd x 12.1yd@100yd'}
                    ]
                },
                {
                    seriesName:'Diaplay Specifications',
                    data:[
                        {name:'Type',val:'Micro-OLED'},
                        {name:'Display Resolution',val:'1024x768 pixels'},
                        {name:'Frame Rate',val:'50Hz'},
                    ]
                }
            ]
        },
        {   name:'HS225',
            img:'https://us.dntoptics.com/cdn/shop/files/HS225_4.jpg?v=1757639208',
            seriesParam:[
                {
                    seriesName:'Thermal Sensor Specifications',
                    data:[
                        {name:'Resolution',val:'256x192 pixels'},
                        {name:'Image Sensor',val:'Uncooled infrared sensor'},
                        {name:'Frame Rate',val:'50FPS'},
                        {name:'Pixel Size',val:'12x12um'},
                        {name:'NETD',val:'≤25mk @25℃'},
                        {name:'Objective Lens Focal Length',val:'25mm'},
                        {name:'Base Magnification',val:'3x'},
                        {name:'Digital Magnification',val:'3-12x'},
                        {name:'Field of View(HxV)',val:'12.3yd@100yd x 9.2yd@100yd'}
                    ]
                },
                {
                    seriesName:'Diaplay Specifications',
                    data:[
                        {name:'Type',val:'Micro-OLED'},
                        {name:'Display Resolution',val:'1024x768 pixels'},
                        {name:'Frame Rate',val:'50Hz'},
                    ]
                }
            ]
        },
        {   name:'HS325',
            img:'https://us.dntoptics.com/cdn/shop/files/HS325_4.jpg?v=1757639206',
            seriesParam:[
                {
                    seriesName:'Thermal Sensor Specifications',
                    data:[
                        {name:'Resolution',val:'384x288 pixels'},
                        {name:'Image Sensor',val:'Uncooled infrared sensor'},
                        {name:'Frame Rate',val:'50FPS'},
                        {name:'Pixel Size',val:'12x12um'},
                        {name:'NETD',val:'≤18mk @25℃'},
                        {name:'Objective Lens Focal Length',val:'25mm'},
                        {name:'Base Magnification',val:'2x'},
                        {name:'Digital Magnification',val:'2-8x'},
                        {name:'Field of View(HxV)',val:'18.4yd@100yd x 13.8yd@100yd'}
                    ]
                },
                {
                    seriesName:'Diaplay Specifications',
                    data:[
                        {name:'Type',val:'Micro-OLED'},
                        {name:'Display Resolution',val:'1024x768 pixels'},
                        {name:'Frame Rate',val:'50Hz'},
                    ]
                }
            ]
        },
        {   name:'HS335',
            img:'https://us.dntoptics.com/cdn/shop/files/HS335-5.jpg?v=1757581132',
            seriesParam:[
                {
                    seriesName:'Thermal Sensor Specifications',
                    data:[
                        {name:'Resolution',val:'384x288 pixels'},
                        {name:'Image Sensor',val:'Uncooled infrared sensor'},
                        {name:'Frame Rate',val:'50FPS'},
                        {name:'Pixel Size',val:'12x12um'},
                        {name:'NETD',val:'≤18mk @25℃'},
                        {name:'Objective Lens Focal Length',val:'35mm'},
                        {name:'Base Magnification',val:'3x'},
                        {name:'Digital Magnification',val:'3-12x'},
                        {name:'Field of View(HxV)',val:'13.2yd@100yd x 9.9yd@100yd'}
                    ]
                },
                {
                    seriesName:'Diaplay Specifications',
                    data:[
                        {name:'Type',val:'Micro-OLED'},
                        {name:'Display Resolution',val:'1024x768 pixels'},
                        {name:'Frame Rate',val:'50Hz'},
                    ]
                }
            ]
        },
        {   name:'HS635',
            img:'https://us.dntoptics.com/cdn/shop/files/HS635_4.jpg?v=1757639204',
            seriesParam:[
                {
                    seriesName:'Thermal Sensor Specifications',
                    data:[
                        {name:'Resolution',val:'640x512 pixels'},
                        {name:'Image Sensor',val:'Uncooled infrared sensor'},
                        {name:'Frame Rate',val:'50FPS'},
                        {name:'Pixel Size',val:'12x12um'},
                        {name:'NETD',val:'≤18mk @25℃'},
                        {name:'Objective Lens Focal Length',val:'35mm'},
                        {name:'Base Magnification',val:'1.5x'},
                        {name:'Digital Magnification',val:'1.5-6x'},
                        {name:'Field of View(HxV)',val:'21.9yd@100yd x 17.6yd@100yd'}
                    ]
                },
                {
                    seriesName:'Diaplay Specifications',
                    data:[
                        {name:'Type',val:'Micro-OLED'},
                        {name:'Display Resolution',val:'1024x768 pixels'},
                        {name:'Frame Rate',val:'50Hz'},
                    ]
                }
            ]
        } ,
        {   name:'HS650',
            img:'https://z5pyujl6lzmu265v-70667763947.shopifypreview.com/cdn/shop/files/HS635R-HYDRA-LRF-640x512-50mm-Multi-Function-Thermal-Scope-01.jpg?v=1760069882',
            seriesParam:[
                {
                    seriesName:'Thermal Sensor Specifications',
                    data:[
                        {name:'Resolution',val:'640x512 pixels'},
                        {name:'Image Sensor',val:'Uncooled infrared sensor'},
                        {name:'Frame Rate',val:'50FPS'},
                        {name:'Pixel Size',val:'12x12um'},
                        {name:'NETD',val:'≤18mk @25℃'},
                        {name:'Objective Lens Focal Length',val:'50mm'},
                        {name:'Base Magnification',val:'2.5x'},
                        {name:'Digital Magnification',val:'2.5-10x'},
                        {name:'Field of View(HxV)',val:'15.4yd@100yd x 11.5yd@100yd'}
                    ]
                },
                {
                    seriesName:'Diaplay Specifications',
                    data:[
                        {name:'Type',val:'Micro-OLED'},
                        {name:'Display Resolution',val:'1024x768 pixels'},
                        {name:'Frame Rate',val:'50Hz'},
                    ]
                }
            ]
        }
    ]
    
var hydraLRFData = [
        {   name:'HS225R',
            img:'https://us.dntoptics.com/cdn/shop/files/HS225R-HYDRA-256x192-25mm-Multi-Function-Thermal-Scope-01.jpg?v=1760068844',
            seriesParam:[
                {
                    seriesName:'Thermal Sensor Specifications',
                    data:[
                        {name:'Resolution',val:'256x192 pixels'},
                        {name:'Image Sensor',val:'Uncooled infrared sensor'},
                        {name:'Frame Rate',val:'50FPS'},
                        {name:'Pixel Size',val:'12x12um'},
                        {name:'NETD',val:'≤25mk @25℃'},
                        {name:'Objective Lens Focal Length',val:'25mm'},
                        {name:'Base Magnification',val:'3x'},
                        {name:'Digital Magnification',val:'3-12x'},
                        {name:'Field of View(HxV)',val:'12.3yd@100yd x 9.2yd@100yd'}
                    ]
                },
                {
                    seriesName:'Diaplay Specifications',
                    data:[
                        {name:'Type',val:'Micro-OLED'},
                        {name:'Display Resolution',val:'1024x768 pixels'},
                        {name:'Frame Rate',val:'50Hz'},
                    ]
                }
            ]
        },
        {   name:'HS335R',
            img:'https://us.dntoptics.com/cdn/shop/files/HS335R-HYDRA-LRF-384x288-35mm-Multi-Function-Thermal-Scope-01.jpg?v=1760068954',
            seriesParam:[
                {
                    seriesName:'Thermal Sensor Specifications',
                    data:[
                        {name:'Resolution',val:'384x288 pixels'},
                        {name:'Image Sensor',val:'Uncooled infrared sensor'},
                        {name:'Frame Rate',val:'50FPS'},
                        {name:'Pixel Size',val:'12x12um'},
                        {name:'NETD',val:'≤18mk @25℃'},
                        {name:'Objective Lens Focal Length',val:'35mm'},
                        {name:'Base Magnification',val:'3x'},
                        {name:'Digital Magnification',val:'3-12x'},
                        {name:'Field of View(HxV)',val:'13.2yd@100yd x 9.9yd@100yd'}
                    ]
                },
                {
                    seriesName:'Diaplay Specifications',
                    data:[
                        {name:'Type',val:'Micro-OLED'},
                        {name:'Display Resolution',val:'1024x768 pixels'},
                        {name:'Frame Rate',val:'50Hz'},
                    ]
                }
            ]
        },
        {   name:'HS635R',
            img:'https://us.dntoptics.com/cdn/shop/files/HS635R-HYDRA-LRF-640x512-35mm-Multi-Function-Thermal-Scope-01.jpg?v=1760069637',
            seriesParam:[
                {
                    seriesName:'Thermal Sensor Specifications',
                    data:[
                        {name:'Resolution',val:'640x512 pixels'},
                        {name:'Image Sensor',val:'Uncooled infrared sensor'},
                        {name:'Frame Rate',val:'50FPS'},
                        {name:'Pixel Size',val:'12x12um'},
                        {name:'NETD',val:'≤18mk @25℃'},
                        {name:'Objective Lens Focal Length',val:'35mm'},
                        {name:'Base Magnification',val:'1.5x'},
                        {name:'Digital Magnification',val:'1.5-6x'},
                        {name:'Field of View(HxV)',val:'21.9yd@100yd x 17.6yd@100yd'}
                    ]
                },
                {
                    seriesName:'Diaplay Specifications',
                    data:[
                        {name:'Type',val:'Micro-OLED'},
                        {name:'Display Resolution',val:'1024x768 pixels'},
                        {name:'Frame Rate',val:'50Hz'},
                    ]
                }
            ]
        },
        {   name:'HS650R',
            img:'https://us.dntoptics.com/cdn/shop/files/HS635R-HYDRA-LRF-640x512-50mm-Multi-Function-Thermal-Scope-01_5b493a49-d1a3-4d6a-94ab-fc5f4bab415a.jpg?v=1760080057',
            seriesParam:[
                {
                    seriesName:'Thermal Sensor Specifications',
                    data:[
                        {name:'Resolution',val:'640x512 pixels'},
                        {name:'Image Sensor',val:'Uncooled infrared sensor'},
                        {name:'Frame Rate',val:'50FPS'},
                        {name:'Pixel Size',val:'12x12um'},
                        {name:'NETD',val:'≤18mk @25℃'},
                        {name:'Objective Lens Focal Length',val:'50mm'},
                        {name:'Base Magnification',val:'2.5x'},
                        {name:'Digital Magnification',val:'2.5-10x'},
                        {name:'Field of View(HxV)',val:'15.4yd@100yd x 11.5yd@100yd'}
                    ]
                },
                {
                    seriesName:'Diaplay Specifications',
                    data:[
                        {name:'Type',val:'Micro-OLED'},
                        {name:'Display Resolution',val:'1024x768 pixels'},
                        {name:'Frame Rate',val:'50Hz'},
                    ]
                }
            ]
        }
]

var ZULUSV1DATA = [
        {   name:'ZHD312R',
            img:'https://us.dntoptics.com/cdn/shop/files/ZHD312R-ZULUSHD3-12XDigitalNightVisionScopewithLaserRangefinderandBallisticCalculator-1.jpg?v=1718605978',
            seriesParam:[
                {
                    seriesName:'Optical Specifications',
                    data:[
                        {name:'Resolution',val:'1920x1080 pixels'},
                        {name:'Sensor Frame Rate',val:'60Hz'},
                        {name:'Video Record Resolution',val:'1920x1080 pixels'},
                        {name:'Base Magnification',val:'3x'},
                        {name:'Digital Magnification',val:'3～12x'},
                        {name:'Field of View(HxV)',val:'13.9yd@100yd x 7.8yd@100yd'},
                        {name:'Eye Relief',val:'45mm'},
                        {name:'Diopter Adjustment',val:'±5D'},
                        {name:'IR Wavelength',val:'850/940nm'}
                    ]
                },
                {
                    seriesName:'Diaplay Specifications',
                    data:[
                        {name:'Type',val:'Micro-OLED'},
                        {name:'Display Resolution',val:'1920x1080 pixels'},
                        {name:'Frame Rate',val:'60Hz'},
                    ]
                }
            ]
        }
]

var ZULUSV2DATA = [
        {   name:'ZHD312R-V2',
            img:'https://us.dntoptics.com/cdn/shop/files/ZHD312R-V2_Front_view-PMS.jpg?v=1751428063',
            seriesParam:[
                {
                    seriesName:'Optical Specifications',
                    data:[
                        {name:'Resolution',val:'1920x1080 pixels'},
                        {name:'Sensor Frame Rate',val:'60Hz'},
                        {name:'Video Record Resolution',val:'1800x1080 pixels'},
                        {name:'Base Magnification',val:'3x'},
                        {name:'Digital Magnification',val:'3～12x'},
                        {name:'Field of View(HxV)',val:'13.9yd@100yd x 7.8yd@100yd'},
                        {name:'Eye Relief',val:'65mm'},
                        {name:'Diopter Adjustment',val:'±3D'},
                        {name:'IR Wavelength',val:'850/940nm'}
                    ]
                },
                {
                    seriesName:'Diaplay Specifications',
                    data:[
                        {name:'Type',val:'Micro-OLED'},
                        {name:'Display Resolution',val:'1920x1080 pixels'},
                        {name:'Frame Rate',val:'60Hz'},
                    ]
                }
            ]
        },
        {   name:'ZHD520R-V2',
            img:'https://us.dntoptics.com/cdn/shop/files/ZHD520R-V2_Front_view-PMS.jpg?v=1751428069',
            seriesParam:[
                {
                    seriesName:'Optical Specifications',
                    data:[
                        {name:'Resolution',val:'1920x1080 pixels'},
                        {name:'Sensor Frame Rate',val:'60Hz'},
                        {name:'Video Record Resolution',val:'1800x1080 pixels'},
                        {name:'Base Magnification',val:'5x'},
                        {name:'Digital Magnification',val:'5～20x'},
                        {name:'Field of View(HxV)',val:'8.6yd@100yd x 4.8yd@100yd'},
                        {name:'Eye Relief',val:'65mm'},
                        {name:'Diopter Adjustment',val:'±3D'},
                        {name:'IR Wavelength',val:'850/940nm'}
                    ]
                },
                {
                    seriesName:'Diaplay Specifications',
                    data:[
                        {name:'Type',val:'Micro-OLED'},
                        {name:'Display Resolution',val:'1920x1080 pixels'},
                        {name:'Frame Rate',val:'60Hz'},
                    ]
                }
            ]
        },
        {   name:'ZHD520-V2',
            img:'https://k8552jn8mry71qq9-70667763947.shopifypreview.com/cdn/shop/files/ZHD520-V2-pms.jpg?v=1754300804',
            seriesParam:[
                {
                    seriesName:'Optical Specifications',
                    data:[
                        {name:'Resolution',val:'1920x1080 pixels'},
                        {name:'Sensor Frame Rate',val:'60Hz'},
                        {name:'Video Record Resolution',val:'1800x1080 pixels'},
                        {name:'Base Magnification',val:'5x'},
                        {name:'Digital Magnification',val:'5～20x'},
                        {name:'Field of View(HxV)',val:'8.6yd@100yd x 4.8yd@100yd'},
                        {name:'Eye Relief',val:'65mm'},
                        {name:'Diopter Adjustment',val:'±3D'},
                        {name:'IR Wavelength',val:'850/940nm'}
                    ]
                },
                {
                    seriesName:'Diaplay Specifications',
                    data:[
                        {name:'Type',val:'Micro-OLED'},
                        {name:'Display Resolution',val:'1920x1080 pixels'},
                        {name:'Frame Rate',val:'60Hz'},
                    ]
                }
            ]
        },
        {   name:'ZHD312-V2',
            img:'https://k8552jn8mry71qq9-70667763947.shopifypreview.com/cdn/shop/files/ZHD312-V2-pms.jpg?v=1754300897',
            seriesParam:[
                {
                    seriesName:'Optical Specifications',
                    data:[
                        {name:'Resolution',val:'1920x1080 pixels'},
                        {name:'Sensor Frame Rate',val:'60Hz'},
                        {name:'Video Record Resolution',val:'1800x1080 pixels'},
                        {name:'Base Magnification',val:'3x'},
                        {name:'Digital Magnification',val:'3～12x'},
                        {name:'Field of View(HxV)',val:'13.9yd@100yd x 7.8yd@100yd'},
                        {name:'Eye Relief',val:'65mm'},
                        {name:'Diopter Adjustment',val:'±3D'},
                        {name:'IR Wavelength',val:'850/940nm'}
                    ]
                },
                {
                    seriesName:'Diaplay Specifications',
                    data:[
                        {name:'Type',val:'Micro-OLED'},
                        {name:'Display Resolution',val:'1920x1080 pixels'},
                        {name:'Frame Rate',val:'60Hz'},
                    ]
                }
            ]
        }
]

var HoundData = [
        {   name:'H315R',
            img:'https://ormcms33pww6u3pg-70667763947.shopifypreview.com/cdn/shop/files/H315R-HoundThermalImagingMonocular-2.jpg?v=1756192799',
            seriesParam:[
                {
                    seriesName:'Thermal Sensor Specifications',
                    data:[
                        {name:'Resolution',val:'384x288 pixels'},
                        {name:'Image Sensor',val:'Uncooled infrared sensor'},
                        {name:'Frame Rate',val:'50FPS'},
                        {name:'Pixel Size',val:'12x12um'},
                        {name:'NETD',val:'≤18mk @25℃'},
                        {name:'Objective Lens Focal Length',val:'15mm'},
                        {name:'Base Magnification',val:'1.5x'},
                        {name:'Digital Magnification',val:'1.5-6x'},
                        {name:'Field of View(HxV)',val:'30.7yd@100yd x 23.0yd@100yd'}
                    ]
                },
                {
                    seriesName:'Diaplay Specifications',
                    data:[
                        {name:'Type',val:'Micro-OLED'},
                        {name:'Display Resolution',val:'1024x768 pixels'},
                        {name:'Frame Rate',val:'50Hz'},
                    ]
                }
            ]
        },        
        {   name:'H325R',
            img:'https://ormcms33pww6u3pg-70667763947.shopifypreview.com/cdn/shop/files/H325R-HoundThermalImagingMonocular-2.jpg?v=1756193206',
            seriesParam:[
                {
                    seriesName:'Thermal Sensor Specifications',
                    data:[
                        {name:'Resolution',val:'384x288 pixels'},
                        {name:'Image Sensor',val:'Uncooled infrared sensor'},
                        {name:'Frame Rate',val:'50FPS'},
                        {name:'Pixel Size',val:'12x12um'},
                        {name:'NETD',val:'≤18mk @25℃'},
                        {name:'Objective Lens Focal Length',val:'25mm'},
                        {name:'Base Magnification',val:'2.5x'},
                        {name:'Digital Magnification',val:'2.5-10x'},
                        {name:'Field of View(HxV)',val:'18.4yd@100yd x 13.8yd@100yd'}
                    ]
                },
                {
                    seriesName:'Diaplay Specifications',
                    data:[
                        {name:'Type',val:'Micro-OLED'},
                        {name:'Display Resolution',val:'1024x768 pixels'},
                        {name:'Frame Rate',val:'50Hz'},
                    ]
                }
            ]
        },        
        {   name:'H635R',
            img:'https://ormcms33pww6u3pg-70667763947.shopifypreview.com/cdn/shop/files/H635R-HoundThermalImagingMonocular-2.jpg?v=1756193275',
            seriesParam:[
                {
                    seriesName:'Thermal Sensor Specifications',
                    data:[
                        {name:'Resolution',val:'640x512 pixels'},
                        {name:'Image Sensor',val:'Uncooled infrared sensor'},
                        {name:'Frame Rate',val:'50FPS'},
                        {name:'Pixel Size',val:'12x12um'},
                        {name:'NETD',val:'≤18mk @25℃'},
                        {name:'Objective Lens Focal Length',val:'35mm'},
                        {name:'Base Magnification',val:'2x'},
                        {name:'Digital Magnification',val:'2-8x'},
                        {name:'Field of View(HxV)',val:'21.9yd@100yd x 17.6yd@100yd'}
                    ]
                },
                {
                    seriesName:'Diaplay Specifications',
                    data:[
                        {name:'Type',val:'Micro-OLED'},
                        {name:'Display Resolution',val:'1024x768 pixels'},
                        {name:'Frame Rate',val:'50Hz'},
                    ]
                }
            ]
        }
]
